import { render, staticRenderFns } from "./NodeTitle.vue?vue&type=template&id=19f8484c&"
import script from "./NodeTitle.vue?vue&type=script&lang=ts&"
export * from "./NodeTitle.vue?vue&type=script&lang=ts&"
import style0 from "./NodeTitle.vue?vue&type=style&index=0&id=19f8484c&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports